module.exports = __webpack_public_path__ + "img/ipc_process.b2386a54.png";